import { useEffect, useState } from "react";
import { useTagTypeList } from "models/tags/apiTag";
import { ColorTag } from "components/ui/atoms/Tag";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { ListItemText } from "@mui/material";
import ListSelectField from "./ListSelectField";

const TagField = ({ tagTypeId, ...props }) => {
  const {
    data: tagTypeList,
    isSuccess: tagTypeListIsSuccess,
    isError: tagTypeListIsError,
  } = useTagTypeList(tagTypeId);

  const [tagDictionary, setTagDictionary] = useState(undefined);

  useEffect(() => {
    if (tagTypeListIsSuccess)
      setTagDictionary(Object.fromEntries(tagTypeList.map((x) => [x.id, x])));
  }, [tagTypeListIsSuccess]);

  const filterOptions = createFilterOptions({
    stringify: (option) => {
      let tag = tagDictionary[option];
      return tag.value + " " + tag.key_words;
    },
  });

  if (tagTypeListIsError) return <>Error</>;
  if (!tagDictionary) return <></>;

  return (
    <ListSelectField
      {...props}
      options={tagTypeList.map((x) => [x.id, x])}
      getOptionLabel={(optionId) => (
        <ListItemText
          key={optionId}
          primary={tagDictionary[optionId]?.value || ""}
          secondary={tagDictionary[optionId]?.key_words || ""}
          sx={{
            m: 0,
          }}
          secondaryTypographyProps={{
            noWrap: true,
          }}
        />
      )}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((tagId, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return <ColorTag tagId={tagId} key={key} {...tagProps} />;
        });
      }}
      filterOptions={filterOptions}
    />
  );
};

export default TagField;
